module.exports = __webpack_public_path__ + "9abd4869bfbc78dcd150118d3f29f756.svg";